module.exports = __webpack_public_path__ + "static/workforce-58300e206861f34342c66dbefa91820b.jpg";